<div  class="cockpit-view">
  <h4 class="pdt-20" translate>m2.sprint3.cockpit.card.chart.funktionswert.title</h4>
  <h5 translate>m2.sprint3.cockpit.card.funktionswert.diagramm</h5>
  <div id="svgChartFunktionswert" class="pdt-30 cockpit-svg-image"></div>
</div>

